import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Container,
  LoadingBounce,
} from '@michelin/acid-components';
import { ChangeLogEntities } from 'Types';
import useCommercialLocation from 'hooks/useCommercialLocation';
import useCustomer from 'hooks/useCustomer';
import { PlainMessage } from 'components/PlainMessage';
import useUtils from 'hooks/useUtils';
import { useCommercialMechanicalServices, useCommercialMechanicalServicesCertificates } from 'hooks/useCommercialServices';
import LastModified from 'components/ChangeLog/LastModified';
import { PageTitle } from 'Utils/CanvasPageTitle';
import CommercialServicesPanel from './CommercialMechanicalServicesPanel';

interface Props {
  action: 'edit' | 'view' | 'add',
}

export function CommercialMechanicalServices(props: Props) {
  const { t } = useTranslation();
  const { stNumber } = useParams<{ stNumber: string }>();
  const commercialQuery = useCommercialLocation(stNumber);
  const customerQuery = useCustomer(stNumber);
  const commercialServices = useCommercialMechanicalServices(stNumber);
  const commercialServicesCertificates = useCommercialMechanicalServicesCertificates(stNumber);
  const { subTitle } = useUtils();

  if (commercialQuery.isLoading || customerQuery.isLoading || commercialServices.isLoading) return <LoadingBounce style={{ height: '70vh' }} />;
  if (!commercialServices.data) return <PlainMessage title={t('Error loading commercial services')} messages={t('Please try again later')} />;

  return (
    <>
      <PageTitle
        title={t('Commercial Mechanical Services')}
        subtitle={subTitle}
        rightItems={(<LastModified entity={ChangeLogEntities.services} />)}
      />
      <Container>
        <CommercialServicesPanel
          services={commercialServices.data}
          certificates={commercialServicesCertificates.data}
          action={props.action}
        />
      </Container>
    </>
  );
}
